import {
	LeftElements,
	LeftPageIndex,
	RightElements,
	RightPageIndex,
} from "../../state/navigation";

import { useRecoilValue } from "recoil";
import { PageIndex } from "../../state/page";
import { ConstrainDimensionsSelector } from "../../state/ui";
import { PositionContext } from "./DisplayElements";
import DisplayElementsChildren from "./DisplayElementsChildren";

function TapElements(): JSX.Element {
	const currentElements = useRecoilValue(LeftElements);
	const constrainDimensions = useRecoilValue(ConstrainDimensionsSelector);
	const leftIndex = useRecoilValue(LeftPageIndex);
	const nextElements = useRecoilValue(RightElements);
	const rightIndex = useRecoilValue(RightPageIndex);
	const pageIndex = useRecoilValue(PageIndex);

	/* which container holds the CURRENT page depends on the tap direction —
	   after a deep link or forward tap it's the RIGHT one. Only the
	   non-current container may be hidden from assistive tech and the tab
	   order, or deep-linked pages are unreadable and untabbable */
	return (
		<>
			<PositionContext.Provider value={"left"}>
				<DisplayElementsChildren
					pageElementsToDisplay={currentElements}
					pageIndex={leftIndex}
					key={`left-${leftIndex}}`}
					aria-hidden={leftIndex !== pageIndex ? true : undefined}
				/>
			</PositionContext.Provider>
			{!constrainDimensions && rightIndex > 1 && (
				<PositionContext.Provider value={"right"}>
					<DisplayElementsChildren
						pageElementsToDisplay={nextElements}
						pageIndex={rightIndex}
						key={`right-${rightIndex}`}
						aria-hidden={rightIndex !== pageIndex ? true : undefined}
					/>
				</PositionContext.Provider>
			)}
		</>
	);
}

export default TapElements;
